/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import './AddContentBlock.scss';
import { Button, Fade, Form, FormGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { Input } from 'components/Forms';
import TemplateService from 'api/TemplateService';

const propTypes = {
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  allowedBlocks: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  onCancel: () => null,
  onCreate: () => null,
  allowedBlocks: [],
};

export default function AddContentBlock(props) {
  const { onCancel, onCreate, allowedBlocks } = props;
  const [contentBlocks, setContentBlocks] = useState([]);
  const [selectedBlockType, setSelectedBlockType] = useState('');
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      id: '',
      title: '',
      description: '',
      contentType: selectedBlockType,
    },
  });
  const blockListQuery = useQuery(
    [],
    () => TemplateService.getAllContentBlocksTypes(),
    {
      enabled: false,
      cacheTime: 0,
      onSuccess: (response) => {
        setContentBlocks([]);
        if (response) {
          let temp = response;
          if (allowedBlocks.length > 0) {
            temp = [];
            response.map((b) => {
              if (
                allowedBlocks.find(
                  (ab) => ab.toLowerCase() === b.id.toString().toLowerCase()
                )
              ) {
                temp.push(b);
              }
              return b;
            });
          }
          setContentBlocks(temp);
        }
      },
    }
  );
  const onSubmit = (formData) => {
    onCreate(formData);
    setValue('title', '');
    setValue('description', '');
    setValue('contentType', '');
  };
  const onBlockTypeSelected = (e, type) => {
    e.preventDefault();
    setSelectedBlockType(type);
    setValue('contentType', type);
  };
  const cancelCreate = (e) => {
    e.preventDefault();
    setValue('title', '');
    setValue('description', '');
    setValue('contentType', 'html');
    onCancel();
  };
  useEffect(() => {
    if (allowedBlocks) {
      blockListQuery.refetch();
    }
  }, [allowedBlocks]);

  if (blockListQuery.isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div data-testid="Wrapper-addContentBlock">
      <Fade in>
        <div className="add-content-block-overlay">
          <Form
            className="add-content-block-form p-4 shadow-lg"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormGroup>
              <div className="d-block mb-2">
                <h4>Step 1: Enter Block Title</h4>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label
                  htmlFor="title"
                  className="d-block small text-muted mb-2"
                >
                  Block title appears above the content block when displaying to
                  the user. Leave empty to now show anything.
                </label>
                <Input
                  type="text"
                  name="title"
                  control={control}
                  placeholder="Enter the block title"
                />
              </div>
            </FormGroup>
            <FormGroup>
              <div className="d-block mb-4 ">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="description" className="d-block mb-2">
                  <strong>
                    Block Description <i className="text-muted">(Optional)</i>
                  </strong>
                </label>
                <Input
                  name="description"
                  control={control}
                  placeholder="Enter the block description"
                />
              </div>
            </FormGroup>
            <FormGroup>
              <div className="d-block mb-4">
                <h4>Step 2: Select type of content to add</h4>
                <div className="content-block-types">
                  {contentBlocks.map(({ id, icon, title }, index) => (
                    <div
                      className={`content-block-type-item${
                        selectedBlockType === id ? ' active' : ''
                      }`}
                      onClick={(e) => onBlockTypeSelected(e, id)}
                      key={`block-${index.toString()}`}
                      data-testid={`Button-type-${id}`}
                    >
                      <span className="icon">
                        {icon && icon.length > 0 && (
                          <FontAwesomeIcon icon={Icons[icon]} />
                        )}
                      </span>
                      <span>{title}</span>
                    </div>
                  ))}
                </div>
              </div>
            </FormGroup>
            <FormGroup>
              <div className="d-block text-center">
                <Button
                  type="submit"
                  variant="primary"
                  size="sm"
                  disabled={selectedBlockType.length === 0}
                >
                  Create Block
                </Button>
                <Button
                  variant="link"
                  className="d-inline-block ms-3"
                  onClick={cancelCreate}
                  size="sm"
                >
                  Cancel
                </Button>
              </div>
            </FormGroup>
          </Form>
        </div>
      </Fade>
    </div>
  );
}
AddContentBlock.propTypes = propTypes;
AddContentBlock.defaultProps = defaultProps;
